<template lang="html">
        <div id="page__price-search" class="toolbar-search">
            <input
                type="text" id="toolbar-input" name="toolbar-input" placeholder="Название..." v-model="filter.search"  class="toolbar-search__input" autocomplete="toolbar-input"
                v-on:keyup.enter="onFilter" ref="toolbar-input"
            />
            <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-bind:disabled="!hasFilter" v-on:click="onReset"></z-icon-button>
        </div>
</template>
<script>
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: { ZIconButton},
        data() {
            return {
                filter: {
                    search: null
                },
                filterDefault: {
                    search: null 
                },
            }
        },
        created() {
            this.resolveQueryFilter();
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            }
        },
        watch: {
            'filter.search'(val) {
                const search = val;
                setTimeout(() => {
                    if (!this.filter.search || !this.filter.search.length) return this.onReset();
                    if (this.filter.search == search) this.onFilter();
                }, 1000);
            }
        },
        methods: {
            /**
             * Фильтрация
             */
            onFilter() {
                this.$router.push({ 
                    name: this.$route.name, 
                    params: this.$route.params, 
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'zones');
            },
            onSearchFilter() {
                let search = this.filter.search
                setTimeout(() => {
                    if (search == this.filter.search) {
                        if (this.filter.search && this.filter.search.length > 2) this.onFilter();
                        else this.onReset();
                    }
                }, 1000)
            },
            /**
             * Подставление фильтра при перезагрузки страницы
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'zones');
            },
            onFocus() {
                this.focus = true;
            },
            onBlur() {
                this.focus = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ZonesToolbar.vue?0cebe18c